<template>
  <section>
    <section></section>
    <v-data-table
      class="revenueNegotiation"
      v-model="revenueNegotiation.selected"
      :headers="headers"
      :items="revenueNegotiation.items"
      :loading="revenueNegotiation.loading"
      :options.sync="paginationAptas"
      :server-items-length="revenueNegotiation.total"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
      }"
      selectable-key
    ></v-data-table>
  </section>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
  name: "DataTableNegociacion",
  components: {},
  data: () => ({
    headers: [
      { text: "ID", value: "id", sortable: false },
      { text: "Contribuinte", value: "contribuinte", sortable: false },
      { text: "Data da Negociação", value: "dataCadastro" },
      { text: "Valor", value: "valorTotal" },
      { text: "Tipo Parcelamento", value: "tipoParcelamento" },
      { text: "Status", value: "grupoReceitaStatus" },
      { text: "Observação", value: "observacao", width: "20%" },
    ],
    revenueNegotiation: [{ items: [], loading: false, total: 0 }],
    paginationAptas: {
      sortBy: ["dataVencimento"],
      sortDesc: [true],
      page: 1,
      itemsPerPage: 10,
    },
  }),
  watch: {
    paginationAptas: {
      handler(val) {
        if (parseInt(this.model.sefazProduto)) {
          // this.searchRevenueNegociation(false);
        }
      },
      deep: true,
    },
  },
});
</script>